import { AbstractControl, ValidatorFn } from '@angular/forms';
import _ from 'lodash';

export class AutoCompleteValidators {
    static mustBeInList = (
        list: Array<any>,
        key: string,
        isObject: boolean = false // if value is an object
    ): ValidatorFn => {

        return (control: AbstractControl) => {
            let result: boolean;
            if (!control.value || _.isEmpty(control.value)) return null;

            if (_.isArray(control.value)) {
                result = _.every(control.value, (v) => {
                    return AutoCompleteValidators.isInside(v, list, key, isObject);
                });
            } else {
                result = AutoCompleteValidators.isInside(control.value, list, key, isObject);
            }
            if (result) {
                return null;
            } else {
                return { mustBeInList: { valid: false } };
            }
        };
    };

    static isInside(value: any, list: Array<any>, key: string, isObject: boolean): boolean {
        if (isObject) {
            return typeof value !== 'object' ? false : true;
        } else {
            const valueToCompare: string | boolean = typeof value === 'object' ? _.get(value, key)?.toLowerCase() : typeof value === 'string' ? value?.toLowerCase() : false;
            if (_.isNil(valueToCompare)) {
                return false;
            } else {
                return list.some((entry) => {
                    if (_.isNil(entry)) {
                        return false;
                    }
                    let currentValue: string;
                    if (typeof entry === 'string') currentValue = entry?.toLowerCase();
                    else currentValue = _.get(entry, key)?.toLowerCase();          
                    return currentValue === valueToCompare;
                });
            }
        }
    }
}
